import de from '@/locales/de.json';
import en from '@/locales/en.json';

export type Locale = 'de' | 'en';

const dictionaries: Record<Locale, Record<string, string>> = {
  de: de as Record<string, string>,
  en: en as Record<string, string>,
};

export const AVAILABLE_LOCALES: { code: Locale; name: string; flag: string }[] = [
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
];

export const DEFAULT_LOCALE: Locale = 'de';

export function detectLocale(): Locale {
  try {
    const match = document.cookie.match(/(?:^|;\s*)kispro-lang=([^;]+)/);
    const cookieLang = match ? decodeURIComponent(match[1]) : null;
    if (cookieLang && cookieLang in dictionaries) return cookieLang as Locale;
  } catch {
    /* ignore */
  }
  const browser = (navigator.language || 'de').slice(0, 2).toLowerCase();
  return browser in dictionaries ? (browser as Locale) : DEFAULT_LOCALE;
}

/**
 * Übersetzungs-Helfer. Fällt bei fehlendem Key auf Deutsch zurück, dann auf den Key selbst.
 * Unterstützt einfache sprintf-Platzhalter (%s) per varargs.
 */
export function translate(locale: Locale, key: string, ...args: Array<string | number>): string {
  const txt = dictionaries[locale]?.[key] ?? dictionaries.de[key] ?? key;
  if (!args.length) return txt;
  let i = 0;
  return txt.replace(/%s/g, () => String(args[i++] ?? ''));
}
